<template>
    <div class="pledge-container">
        <el-dialog :title="$t('views_home_components_pledge_43')" :visible="visible" width="100%" @close="visible = false">
            <span>
                <el-form>
                    <el-form-item size="mini">
                        <el-col :span="6">
                            {{$t('views_home_components_pledge_sales_price')}}
                        </el-col>
                        <el-col :span="18">
                            <el-input size="mini" label="" v-model="salesPrice" :controls="true" controls-position="both" disabled aria-readonly="true">
                                <el-button slot="append">USDT</el-button>
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item :gutter="20">
                        <el-col :span="12">
                                <el-input v-model="firstName" @change="onChange" size="mini" label="" :controls="true" controls-position="both" :placeholder="$t('First Name')">
                                </el-input>
                        </el-col>
                        <el-col :span="12">
                            <el-input v-model="lastName" size="mini" label="" :controls="true" controls-position="both" :placeholder="$t('Last Name')">
                            </el-input>
                        </el-col>
                    </el-form-item>
                    <el-form-item :gutter="20">
                        <el-input v-model="contactMethods" size="mini" label="" :controls="true" controls-position="both" :placeholder="$t('Contact Method')">
                            <el-select style="width:120px" @change="changeCountryCode" v-model="countryCode" size="mini" slot="prepend" :placeholder="$t('Please choose')" :filterable="true">
                                <el-option v-for="(item,index) in countryCodeList" :key="index" :label="item.label" :value="index">
                                </el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="street" size="mini" :label="$t('Details address')" :controls="true" controls-position="both" :placeholder="$t('Details Address')">
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-col :span="12">
                            <el-select v-model="countrySlug" @change="handleCountryChange" size="mini" :placeholder="$t('Country')" :filterable="true">
                                <el-option v-for="item in countryList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <el-select v-model="provinceSlug" placeholder="Please select" size="mini" :filterable="true">
                                <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>
                    <el-form-item prop="city" size="mini">
                        <el-input v-model="city" :placeholder="$t('cities of Province')" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item size="mini">
                        <el-input v-model="postalCode" size="mini" label="" @keypress="onlyNumbers" :controls="true" controls-position="both" :placeholder="$t('Postal code')">
                        </el-input>
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer">
                <el-button type="success" :loading="buttonLoading"
                    @click="buy" size="small">{{$t('views_community_components_promotion_levels_16')}}</el-button>
            </span>
        </el-dialog>

        <!-- <div class="product-info">
            <div v-if="productInfo">
                <h2>{{ productInfo.name }}</h2>
                <p>Price: {{ productInfo.price }}</p>
            </div>
            <div v-else>
                Loading product information...
            </div>
        </div> -->
    </div>
</template>
<script>
import i18n from '../../../locales/index'

import clock_wise from "@/config/mobile_sale_abi";
import { getMobileSaleContract, getCoinContract, getSaleStorageContract, getProductManagerContract } from "@/utils/contract";
import { addProduct, updateOrder } from '@/utils/http';
import infuraWeb3 from "@/utils/infura";
import web3 from "@/utils/myweb3";
import encodeMixedRoute from '@/utils/v4_router';
import { mapState } from "vuex";
import Web3 from "web3";
// import IsoCountries from 'i18n-iso-countries'
// import Iso6391 from "iso-639-1";
import countryData from 'country-data';
import countryRegionData from 'country-region-data/dist/data-umd';
import { allCountries, countryTuples,countryShortCodes,countryNames } from "country-region-data";
import en from "i18n-iso-countries/langs/en.json";
import zh from "i18n-iso-countries/langs/zh.json";
import ru from "i18n-iso-countries/langs/ru.json";
import { THIRD_PARTY_PRODUCT_ID } from "@/utils/contract"; // 配置文件路径请替换

export default {
    props:{
        userInfo:{}
    },

    watch: {
        visible() {
            if (this.visible) {
                this.lastAmout = -1;
                this.$nextTick(() => {
                    // this.$refs.amount.$el.children[2].children[0].setAttribute('readonly',true)
                    this.loadContactInfo();
                })
            }
        },
        countryCode(newVal, oldVal) {
            console.log(newVal, oldVal, "countryCode");
            this.phoneCode = this.countryCodeList[newVal].value;
            console.log(this.phoneCode);
        },
        countrySlug(newVal, oldVal) {
            console.log(newVal, oldVal, "countrySlug");
            this.country = this.countryList.find(item => item.value === newVal).label;
            console.log(this.country, "country name")
        },
        provinceSlug(newVal, oldVal) {
            console.log(newVal, oldVal, "provinceSlug");
            this.province = this.provinceList.find(item => item.value === newVal).label;
            console.log(this.province, "province name")
        },
        '$i18n.locale'() {
            const locale = this.$i18n.locale;
            this.countryList = countryTuples.map(d=> {
                const item = {
                    label: this.$t('countries["'+ d[0] +'"]', {language: locale}),
                    value: d[1].replace('+', '')
                }
                return item;
            });
            this.provinceList = countryRegionData.filter(d=>d.countryShortCode==='CN')[0].regions.map(d=> {
                const item = {
                    label: this.$t('countries["'+ d.name +'"]', {language: locale}),    
                    value: d.shortCode
                }
                return item;
            });
            this.countryCodeList = countryData.callingCountries.all.map(d=> {
                const item = {
                    label: d.emoji + " " + d.countryCallingCodes[0],
                    value: d.countryCallingCodes[0]
                }
                return item;
            });
        },
        productInfo: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.price !== undefined) {
                    this.productPrice = newVal.price;
                }
            }
        },
        usdtDecimals() {
            this.$forceUpdate();
        }
    },
    data() {
        return {
            visible: false,
            amount: 1,
            lastAmout: -1,
            buttonLoading: false,
            country: '',
            province: '',
            countrySlug: '',
            provinceSlug: '',
            city: '',
            productPrice: null,
            countryList: [],
            cityList: [],
            provinceList: [],
            postalCode: '',
            street: '',
            contactMethods: '',
            firstName: '',
            lastName: '',
            phoneCode: '',
            countryCode: null,
            countryCodeList: [],
            graphState: 1,  // 1 增强型 2 极简型
            loading: null,
            usdtDecimals: 18,
        }
    },
    computed: {  
        ...mapState(['userAdd', 'productInfo']),
        // 派生字段通过计算属性生成  
        fullName() {  
            return `${this.firstName} ${this.lastName}`.trim()   
        },  
        address() {  
            return [this.province, this.city].filter(Boolean).join(',')   
        },  
        phoneNumber() {  
            return `${this.phoneCode} ${this.contactMethods}`.trim()   
        },
        salesPrice() {
            const decimals = Number(this.usdtDecimals) || 18;
            const price = this.productPrice ? Number(this.productPrice) : 0;
            if (!price) return '0';
            return (price / Math.pow(10, decimals)).toFixed(2);
        },
        formData() {
           let data = {
                fullName: this.fullName,
                firstName: this.firstName,
                lastName: this.lastName,
                street: this.street,
                address: this.address,
                region: this.province,
                regionSlug: this.provinceSlug,
                city: this.city,
                phoneCode: this.phoneCode,
                phone: this.contactMethods,
                phoneNumber: this.phoneNumber,
                postalCode: this.postalCode,
                country: this.country,
                countrySlug: this.countrySlug,
            };
            localStorage.setItem('contactInfo', JSON.stringify(data));
            return data;
        }
    },  
    created() {
        const locale = this.$i18n.locale;
        this.countryList = countryTuples.map(d=> {
            const item = {
                label: this.$t('countries["'+ d[0] +'"]', {language: locale}),
                value: d[1].replace('+', '')
            }
            return item;
        });
        this.provinceList = countryRegionData.filter(d=>d.countryShortCode==='CN')[0].regions.map(d=> {
            const item = {
                label: this.$t('countries["'+ d.name +'"]', {language: locale}),    
                value: d.shortCode
            }
            return item;
        });
        this.countryCodeList = countryData.callingCountries.all.map(d=> {
            const item = {
                label: d.emoji + " " + d.countryCallingCodes[0],
                value: d.countryCallingCodes[0]
            }
            return item;
        });
        this.countrySlug = "CN";
        this.provinceSlug = "GD";
        this.countryCode = 47;
        this.$nextTick(()=>{
            this.$forceUpdate();
        })
    },
    mounted() {
        // IsoCountries.registerLocale(en); // 例如使用英语
        // IsoCountries.registerLocale(zh); // 例如使用中
        // IsoCountries.registerLocale(ru); // 例如使用中文
        if(!localStorage.getItem("buyMobileIndex")){
            localStorage.setItem("buyMobileIndex",0);
        }
        const locale = this.$i18n.locale;
        this.countryList = countryTuples.map(d=> {
            const item = {
                label: this.$t('countries["'+ d[0] +'"]', {language: locale}),
                value: d[1].replace('+', '')
            }
            return item;
        });
        this.provinceList = countryRegionData.filter(d=>d.countryShortCode==='CN')[0].regions.map(d=> {
            const item = {
                label: this.$t('countries["'+ d.name +'"]', {language: locale}),    
                value: d.shortCode
            }
            return item;
        });
        this.countryCodeList = countryData.callingCountries.all.map(d=> {
            const item = {
                label: d.emoji + " " + d.countryCallingCodes[0],
                value: d.countryCallingCodes[0]
            }
            return item;
        });
        this.requestProduct()
        this.graphState = 1
        this.processPendingTx()
        this.processRetryQueue()
        this.getUsdtDecimals();
    },
    methods: {
        // 精度仅来自 USDT 合约（getCoinContract），与销售合约无关；更新销售合约不会影响此处
        async getUsdtDecimals() {
            const provider = window.myprovider || window.ethereum;
            if (!provider) {
                console.warn('Provider not available, skip getUsdtDecimals');
                this.usdtDecimals = 18;
                return;
            }
            const coinContract = getCoinContract && getCoinContract();
            if (!coinContract || !coinContract.methods || !coinContract.methods.decimals) {
                console.warn('Coin contract not initialized, skip getUsdtDecimals');
                this.usdtDecimals = 18;
                return;
            }
            if (!coinContract.currentProvider && coinContract.setProvider) {
                coinContract.setProvider(provider);
            }
            try {
                const decimals = await coinContract.methods.decimals().call();
                this.usdtDecimals = Number(decimals);
                console.log('USDT decimals:', this.usdtDecimals);
            } catch (err) {
                console.error('Failed to get decimals from chain:', err);
                // 链上 USDT 地址/ABI 不匹配或 RPC 异常时会进这里，用 18 兜底
                this.usdtDecimals = 18;
                console.warn('Using default decimals: 18');
            }
        },
        processPendingTx(){
            const strPendingTx = localStorage.getItem('pendingTx'); 
            if(!strPendingTx) return;
            const pendingTx = JSON.parse(strPendingTx);
            pendingTx.forEach(async item => {
                if(item.status == "pending") {
                    this.loading = this.$loading({body: true, text: "process pending tx by:" + item.txHash});
                    await this.startRetryMonitor(item.txHash);
                }
            });
        },
        covertBigIntsToNumber(obj) {
            for (const key in obj) {
                if (typeof obj[key] === 'bigint') {
                    // 转换 BigInt 为普通数字
                    obj[key] = Number(obj[key]);
                } else if (Array.isArray(obj[key])) {
                    // 处理数组
                    obj[key] = obj[key].map(item => {
                        if (typeof item === 'bigint') {
                            return Number(item);
                        } else if (typeof item === 'object' && item !== null) {
                            // 递归处理对象
                            return this.covertBigIntsToNumber(item);
                        }
                        return item;
                    });
                } else if (typeof obj[key] === 'object' && obj[key] !== null) {
                    // 递归处理对象
                    this.covertBigIntsToNumber(obj[key]);
                }
            }
            return obj; // 返回处理后的对象
        },
        async requestProduct() {
            try {
                if (!this.productInfo) {
                    console.warn('Product info not found');
                    return;
                }

                // Set product price
                this.productPrice = this.productInfo.price;
                
                // Check if product is active
                if (!this.productInfo.isActive) {
                    console.warn('Product is not active');
                    return;
                }
                
                console.log('Product info:', {
                    id: this.productInfo.id,
                    name: this.productInfo.name,
                    description: this.productInfo.description,
                    price: this.productInfo.price,
                    swapAmount: this.productInfo.swapAmount,
                    isActive: this.productInfo.isActive,
                    strategyContract: this.productInfo.strategyContract
                });
            } catch (error) {
                console.error('Error requesting product:', error);
            }
        },
        loadContactInfo() {  
            try {  
                const rawData = localStorage.getItem("contactInfo")   
                if (!rawData) return  
                // 避免解析非 JSON 字符串（如曾被错误存为 "[object Object]"）
                const trimmed = rawData.trim()
                if (trimmed === '[object Object]' || (!trimmed.startsWith('{') && !trimmed.startsWith('['))) {
                    return
                }
                const contactInfo = JSON.parse(rawData)
                
                // 原子字段直接赋值  
                const atomicFields = [  
                'firstName', 'lastName', 'street', 'province',  
                'city', 'phoneCode', 'contactMethods', 'postalCode',  
                'country', 'provinceSlug', 'countrySlug'  
                ]  
                atomicFields.forEach(field  => {  
                    if (contactInfo[field] !== undefined) {  
                        this[field] = contactInfo[field]  
                    }  
                })
        
                // 处理特殊复合字段（如从address拆解province/city）  
                if (contactInfo.address)  {  
                    const [province, city] = contactInfo.address.split(',')   
                    this.province  = province || this.province   
                    this.city  = city || this.city   
                }  
                this.contactMethods = contactInfo.phone
                console.log(rawData, "loadContactInfo")
            } catch (error) {  
                console.error(' 联系人信息加载失败:', error)  
            }  
        },  
        handleCountryChange(e) {
            const locale = this.$i18n.locale;
            this.provinceList =countryRegionData.filter(d=>d.countryShortCode===e)[0].regions.map(d=> {
                const item = {
                    label: this.$t("countries[\""+ d.name +"\"]", {language: locale}),
                    value: d.shortCode
                }
                return item;
            }); 
            this.provinceSlug = this.provinceList[0].value;
        },
        changeCountryCode(e) {
            console.log(e)
        },
        onlyNumbers(event) {
            // 允许输入小数点
            const isValid = (event.keyCode >= 48 && event.keyCode <= 57) ||
                // 允许删除和退格键
                event.keyCode === 8 || event.keyCode === 46 ||
                // 允许输入小数点
                //(event.keyCode === 190 || event.keyCode === 110) ||
                // 允许Ctrl+A 全选
                (event.ctrlKey && event.keyCode === 65) ||
                // 允许Ctrl+X 剪切
                (event.ctrlKey && event.keyCode === 88) ||
                // 允许Ctrl+V 粘贴
                (event.ctrlKey && event.keyCode === 86) ||
                // 允许Ctrl+Z 撤销
                (event.ctrlKey && event.keyCode === 90);

            if (!isValid) {
                event.preventDefault();
            }
        },
        onChange() {
            console.log(this.formData);
        },
        amountChange(newVal, oldVal) {
            if(!(newVal+"").endsWith("00")){
                this.$nextTick(()=>{
                    this.$message.error(i18n.t('views_home_components_pledge_45'))
                    this.$forceUpdate();
                })
                return
            }
        },
        async handleSuccess(receipt) {
            try {
                // 更新本地存储状态
                const pendingTx = JSON.parse(localStorage.getItem('pendingTx')) || [];
                const updatedPendingTx = pendingTx.map(tx => {
                    if (tx.txHash === receipt.transactionHash) {
                        return { ...tx, status: 'confirmed' };
                    }
                    return tx;
                });
                localStorage.setItem('pendingTx', this.serializeBigInt(updatedPendingTx));

                // 获取当前交易
                const curPendingTx = updatedPendingTx.find(tx => tx.txHash === receipt.transactionHash);
                if (!curPendingTx) {
                    console.warn('Pending transaction not found:', receipt.transactionHash);
                    return;
                }

                // 解析交易日志（支持 receipt.logs 或 receipt.events 两种格式）
                let purchaseEvent = null;
                const receiptLogs = Array.isArray(receipt.logs) ? receipt.logs : [];
                if (receiptLogs.length > 0) {
                    const decodedLogs = this.decodeReceiptLogs(receiptLogs);
                    purchaseEvent = (decodedLogs || []).find(log => log && log.event === 'PurchaseCompleted');
                }
                if (!purchaseEvent && receipt.events && receipt.events.PurchaseCompleted) {
                    const pc = receipt.events.PurchaseCompleted;
                    purchaseEvent = Array.isArray(pc) ? pc[0] : pc;
                }
                if (!purchaseEvent || !purchaseEvent.returnValues) {
                    throw new Error('PurchaseCompleted event not found in transaction logs');
                }

                // 同步到第三方
                await this.syncToThirdParty(
                    curPendingTx.thirdPartyOrderId,
                    receipt.transactionHash,
                    purchaseEvent
                );

                // 清理交易记录
                this.cleanupTransaction(curPendingTx);

            } catch (error) {
                console.error('Error in handleSuccess:', error);
                throw error;
            }
        },
        handleError(error) {
            this.loading?.close();
            this.buttonLoading = false;
            this.$message.error(error.message || this.$t('views_home_components_pledge_50'));
        },
        providers() {
            const isTestnet = process.env.NODE_ENV === 'development';
            const providers = isTestnet ? [
                new Web3.providers.HttpProvider('https://bsc-testnet-rpc.publicnode.com'),
                new Web3.providers.HttpProvider('https://data-seed-prebsc-1-s3.bnbchain.org:8545'),
                new Web3.providers.HttpProvider('https://data-seed-prebsc-2-s3.bnbchain.org:8545')
            ] : [
                new Web3.providers.HttpProvider('https://bsc-rpc.publicnode.com'),
                new Web3.providers.HttpProvider('https://bsc-dataseed.binance.org'),
                new Web3.providers.HttpProvider('https://bsc-dataseed1.defibit.io')
            ];

            return providers;
        },
        // 更新 BigInt 序列化方法
        serializeBigInt(obj) {
            if (obj === null || obj === undefined) {
                return JSON.stringify(obj);
            }

            return JSON.stringify(obj, (key, value) => {
                if (typeof value === 'bigint') {
                    return value.toString();
                }
                if (value && typeof value === 'object' && value._isBigNumber) {
                    return value.toString();
                }
                return value;
            });
        },
        // 更新 BigNumber 转换工具函数
        convertBigNumberToJson(obj) {
            if (obj === null || obj === undefined) {
                return obj;
            }

            // 处理 BigInt
            if (typeof obj === 'bigint') {
                return obj.toString();
            }

            // 处理 BigNumber
            if (obj._isBigNumber) {
                return obj.toString();
            }

            // 处理数组
            if (Array.isArray(obj)) {
                return obj.map(item => this.convertBigNumberToJson(item));
            }

            // 处理对象
            if (typeof obj === 'object') {
                const result = {};
                for (const key in obj) {
                    if (Object.prototype.hasOwnProperty.call(obj, key)) {
                        result[key] = this.convertBigNumberToJson(obj[key]);
                    }
                }
                return result;
            }

            // 返回原始值
            return obj;
        },
        decodeReceiptLogs(logs) {
            if (!logs || !Array.isArray(logs)) {
                console.error('Invalid logs data:', logs);
                return [];
            }

            return logs.map(log => {
                try {
                    const web3 = new Web3(this.providers()[0]);
                    const contract = new web3.eth.Contract(clock_wise.abi, clock_wise.address);
                    
                    // 计算事件签名
                    const eventSignature = web3.utils.keccak256(
                        'PurchaseCompleted(uint256,address,uint256)'
                    ).slice(0, 10);

                    // 查找匹配的事件 ABI
                    const eventAbi = contract.options.jsonInterface.find(
                        abi => abi.type === 'event' && 
                        (abi.signature === log.topics[0] || abi.signature === eventSignature)
                    );

                    if (!eventAbi) {
                        console.warn('Event ABI not found for topic:', log.topics[0], 'Expected:', eventSignature);
                        return null;
                    }

                    // 解析事件数据
                    const decodedLog = web3.eth.abi.decodeLog(
                        eventAbi.inputs,
                        log.data,
                        log.topics.slice(1)
                    );

                    // 转换所有 BigNumber 为字符串
                    const convertedReturnValues = this.convertBigNumberToJson(decodedLog);

                    // 添加 chainId 和 token 信息
                    const result = {
                        event: eventAbi.name,
                        returnValues: {
                            ...convertedReturnValues,
                            chainId: process.env.NODE_ENV === 'development' ? 97 : 56,
                            token: getCoinContract().options.address
                        },
                        transactionHash: log.transactionHash,
                        blockNumber: Number(log.blockNumber),
                        blockHash: log.blockHash,
                        raw: {
                            ...log,
                            data: log.data,
                            topics: log.topics
                        }
                    };

                    return result;
                } catch (error) {
                    console.error('Error decoding log:', error, log);
                    return null;
                }
            }).filter(Boolean);
        },
        decodeLogs(logs) {
            return logs.map(log => {
                try {

                    const web3 = new Web3(this.providers()[0]);
                    const contract = new web3.eth.Contract(clock_wise.abi, clock_wise.address);
                    let aabi = contract.options.jsonInterface.find(abi => abi.signature === log.signature);
                    if(aabi) {
                        console.log('log', log, contract, contract.options.jsonInterface, aabi)
                        console.log('aabi', aabi, web3)
                        let decodeLog = web3.eth.abi.decodeLog(aabi.inputs, log.data, log.topics.slice(1));
                        console.log('decodeLog', decodeLog)
                        return decodeLog;
                    } else {
                        return null;
                    }
                } catch {
                    return null;
                }
            }).filter(Boolean);
        },
        async switchProvider(txHash) {
            for (const provider of this.providers()) {
                try {
                const web3 = new Web3(provider);
                const receipt = await web3.eth.getTransactionReceipt(txHash);
                console.log(`Received receipt from provider ${receipt}`);
                if (receipt) return receipt;
                } catch (error) {
                console.warn(`Provider ${provider.host} failed`);
                }
            }
            throw new Error('All providers unavailable');
        },
        startRetryMonitor(txHash) {
            const maxRetries = 5;
            let attempts = 0;
           
            const web3 = new Web3(this.providers()[0]); 
            const retry = async () => {
                try {
                    const receipt = await web3.eth.getTransactionReceipt(txHash);
                    if (receipt?.status) {
                        let event = null;
                        const logs = Array.isArray(receipt.logs) ? receipt.logs : [];
                        if (logs.length > 0) {
                            const decoded = this.decodeReceiptLogs(logs);
                            event = (decoded || []).find(e => e && e.event === 'PurchaseCompleted');
                        }
                        if (!event && receipt.events && receipt.events.PurchaseCompleted) {
                            const pc = receipt.events.PurchaseCompleted;
                            event = Array.isArray(pc) ? pc[0] : pc;
                        }
                        if (event && event.returnValues) {
                            const productId = (event.returnValues.productId || '').toString().toLowerCase();
                            const expectedId = (this.productInfo.id || '').toString().toLowerCase();
                            if (productId === expectedId) {
                                await this.handleSuccess(receipt);
                            } else {
                                console.error('Product ID mismatch:', productId, this.productInfo.id);
                                this.handleError(new Error('Product ID mismatch'));
                            }
                        }
                    } else if (attempts < maxRetries) {
                        attempts++;
                        setTimeout(retry, Math.pow(2, attempts) * 1000);
                    } else {
                        // 交易超时，加入离线处理队列
                        const pendingTx = JSON.parse(localStorage.getItem('pendingTx'));
                        const tx = pendingTx.find(t => t.txHash === txHash);
                        if (tx) {
                            this.handleOfflineTransaction(tx);
                        }
                    }
                } catch (error) {
                    this.handleError(error);
                }
            };
            
            retry();
        },
        validateForm() {
            if (!this.firstName) {
                this.$message.error(this.$t('First Name') + this.$t(' is required'));
                return false;
            }
            if (!this.lastName) {
                this.$message.error(this.$t('Last Name') + this.$t(' is required'));
                return false;
            }
            if (!this.contactMethods) {
                this.$message.error(this.$t('Contact Method') + this.$t(' is required'));
                return false;
            }
            if (!this.street) {
                this.$message.error(this.$t('Details Address') + this.$t(' is required'));
                return false;
            }
            if (!this.countrySlug) {
                this.$message.error(this.$t('Country') + this.$t(' is required'));
                return false;
            }
            if (!this.provinceSlug) {
                this.$message.error(this.$t('Province') + this.$t(' is required'));
                return false;
            }
            if (!this.city) {
                this.$message.error(this.$t('cities of Province') + this.$t(' is required'));
                return false;
            }
            if (!this.postalCode) {
                this.$message.error(this.$t('Postal code') + this.$t(' is required'));
                return false;
            }
            return true;
        },
        async buy() {
            let loading;
            try {
                // 表单校验
                if (!this.validateForm()) {
                    return;
                }

                loading = this.$loading({ body: true });
                this.loading = loading;
                this.buttonLoading = true;

                // 检查是否已购买
                const storageContract = getSaleStorageContract();
                const productData = await storageContract.methods.getProductData(this.userAdd, this.productInfo.id).call();
                if (productData.hasPurchased) {
                    this.$message.error(this.$t('Already purchased'));
                    loading.close();
                    this.buttonLoading = false;
                    return;
                }

                // 同步产品信息
                if (await this.syncProductInfo()) {
                    loading.close();
                    this.buttonLoading = false;
                    return;
                }

                // 获取合约实例
                let coinContract = getCoinContract();
                let clockContract = getMobileSaleContract();

                // 检查余额和授权
                let amount = this.productInfo.price;
                let balance = await coinContract.methods.balanceOf(this.userAdd).call();
                if (web3.utils.toBN(balance).lt(web3.utils.toBN(amount))) {
                    this.handleError(new Error(
                        this.$t('views_home_components_pledge_48'))
                    );
                    console.warn("This error is expected because the balance is less than the amount or value is not a valid number object type"); 
                    loading.close();
                    this.buttonLoading = false;
                    return;
                }
                console.warn(this.$t('views_home_components_pledge_48')
                        + " price: " + amount + typeof(web3.utils.toBN(amount)) + " " + amount.toString() + " balance: " + balance + typeof(web3.utils.toBN(balance)) + " " + balance.toString())

                let allowance = await coinContract.methods.allowance(this.userAdd, clockContract.options.address).call();
                if (web3.utils.toBN(allowance).lt(web3.utils.toBN(amount))) {
                    try {
                        await coinContract.methods.approve(clockContract.options.address, amount)
                            .send({ from: this.userAdd });
                    } catch (error) {
                        if (error.message && error.message.includes('User rejected the request')) {
                            this.$message.error(this.$t('User rejected the request'));
                            loading.close();
                            this.buttonLoading = false;
                        } else {
                            this.handleError(error);
                        }
                        return;
                    }
                }

                // 先写入订单
                let contactInfo = this.formData;
                let orderInfo = await addProduct(this.userAdd, 1, this.salesPrice, contactInfo);

                // 发送购买交易
                const receipt = await clockContract.methods.purchaseProduct()
                    .send({ from: this.userAdd })
                    .catch(error => {
                        if (error.message && (
                            error.message.includes('User denied') || 
                            error.message.includes('User rejected') ||
                            error.message.includes('User cancelled') ||
                            error.message.includes('MetaMask Tx Signature: User denied')
                        )) {
                            this.$message.warning(this.$t('Transaction rejected by user'));
                            loading?.close();
                            this.buttonLoading = false;
                            return null;
                        }
                        throw error;
                    });
                console.log('receipt', receipt)
                if (!receipt) return;

                const receiptLogs = Array.isArray(receipt.logs) ? receipt.logs : [];
                if (receiptLogs.length === 0 && receipt.logs !== undefined) {
                    console.warn('receipt.logs is not an array:', receipt.logs);
                }

                // 详细打印交易回执
                console.log('Full Transaction Receipt:', {
                    // 基本信息
                    transactionHash: receipt.transactionHash,
                    blockNumber: receipt.blockNumber,
                    blockHash: receipt.blockHash,
                    status: receipt.status,
                    from: receipt.from,
                    to: receipt.to,
                    contractAddress: receipt.contractAddress,
                    cumulativeGasUsed: receipt.cumulativeGasUsed,
                    gasUsed: receipt.gasUsed,
                    effectiveGasPrice: receipt.effectiveGasPrice,
                    
                    // 事件日志
                    logs: receiptLogs.map(log => ({
                        address: log.address,
                        topics: log.topics,
                        data: log.data,
                        blockNumber: log.blockNumber,
                        transactionHash: log.transactionHash,
                        logIndex: log.logIndex,
                        blockHash: log.blockHash,
                        removed: log.removed
                    })),
                    
                    // 其他信息
                    type: receipt.type,
                    networkId: receipt.networkId,
                    events: receipt.events
                });

                // 验证交易状态
                if (!receipt.status) {
                    console.error('Transaction failed:', {
                        hash: receipt.transactionHash,
                        status: receipt.status,
                        gasUsed: receipt.gasUsed,
                        effectiveGasPrice: receipt.effectiveGasPrice
                    });
                    throw new Error('Transaction failed: ' + receipt.transactionHash);
                }

                // 解析交易日志：优先从 receipt.logs 解码，若无 logs 则从 receipt.events 读取（部分 RPC 返回格式）
                let purchaseEvent = null;
                if (receiptLogs.length > 0) {
                    const decodedLogs = this.decodeReceiptLogs(receiptLogs);
                    console.log('Decoded Event Logs:', decodedLogs);
                    purchaseEvent = (decodedLogs || []).find(log => log && log.event === 'PurchaseCompleted');
                }
                if (!purchaseEvent && receipt.events && receipt.events.PurchaseCompleted) {
                    const pc = receipt.events.PurchaseCompleted;
                    purchaseEvent = Array.isArray(pc) ? pc[0] : pc;
                }
                if (!purchaseEvent || !purchaseEvent.returnValues) {
                    const fromDecoded = receiptLogs.length > 0 ? (this.decodeReceiptLogs(receiptLogs) || []).filter(Boolean).map(log => log.event) : [];
                    const fromEvents = receipt.events ? Object.keys(receipt.events).filter(k => !Array.isArray(receipt.events[k]) && receipt.events[k].event) : [];
                    console.error('PurchaseCompleted event not found in logs:', {
                        transactionHash: receipt.transactionHash,
                        availableEvents: fromDecoded.length ? fromDecoded : fromEvents
                    });
                    throw new Error('PurchaseCompleted event not found in transaction logs');
                }

                // 验证事件数据
                if (!purchaseEvent.returnValues || !purchaseEvent.returnValues.productId) {
                    console.error('Invalid PurchaseCompleted event data:', purchaseEvent);
                    throw new Error('Invalid PurchaseCompleted event data');
                }

                // 验证产品ID（兼容 hex bytes32 与字符串比较）
                const receivedProductId = (purchaseEvent.returnValues.productId || '').toString().toLowerCase();
                const expectedProductId = (this.productInfo.id || '').toString().toLowerCase();
                if (receivedProductId !== expectedProductId) {
                    console.error('Product ID mismatch:', {
                        expected: this.productInfo.id,
                        received: purchaseEvent.returnValues.productId,
                        event: purchaseEvent
                    });
                    // throw new Error('Product ID mismatch in PurchaseCompleted event');
                } else {
                    purchaseEvent.returnValues.productId = this.productInfo.id;
                    console.warn("purchaseEvent productId not match, set to", this.productInfo.id)
                }

                // 更新订单状态
                try {
                    // 确保事件数据是 JSON 可序列化的
                    const serializedEvent = this.convertBigNumberToJson(purchaseEvent);
                    
                    serializedEvent.returnValues.chainId = process.env.NODE_ENV === 'development' ? 97 : 56;
                    serializedEvent.returnValues.token = getCoinContract().options.address;
                    // 打印更新订单的数据
                    console.log('Updating order with data:', {
                        orderId: orderInfo.id,
                        txHash: receipt.transactionHash,
                        event: serializedEvent
                    });

                    await updateOrder(orderInfo.id, receipt.transactionHash, serializedEvent);

                    // 存储待处理交易
                    this.storePendingTransaction(receipt.transactionHash, orderInfo.id);

                    // 处理成功
                    await this.handleSuccess(receipt);
                    
                    // 同步产品信息
                    await this.syncProductInfo();
                    
                    // 处理重试队列
                    await this.processRetryQueue();

                    loading?.close();
                    this.visible = false;
                    this.$message.success(i18n.t('views_home_components_pledge_49'));

                } catch (error) {
                    console.error('Error updating order:', {
                        error,
                        orderId: orderInfo.id,
                        txHash: receipt.transactionHash,
                        event: purchaseEvent
                    });
                    this.addToRetryQueue(orderInfo.id, receipt.transactionHash, purchaseEvent);
                    this.handleError(error);
                }

            } catch (error) {
                console.error('Transaction error:', {
                    error,
                    message: error.message,
                    code: error.code,
                    data: error.data
                });
                this.handleError(error);
            } finally {
                loading?.close();
                this.buttonLoading = false;
            }
        },
        // 同步产品信息
        async syncProductInfo() {
            try {
                const productManagerContract = getProductManagerContract();
                const productInfo = await productManagerContract.methods.getProduct(this.productInfo.id).call();
                
                // 检查产品信息是否有变化
                if (this.hasProductInfoChanged(productInfo)) {
                    // 更新 store 中的产品信息
                    store.dispatch('updateProductInfo', {
                        id: productInfo.id,
                        name: productInfo.name,
                        description: productInfo.description,
                        price: productInfo.price,
                        swapAmount: productInfo.swapAmount,
                        isActive: productInfo.isActive,
                        strategyContract: productInfo.strategyContract
                    });
                    
                    this.$message.warning(this.$t('Product information has been updated'));
                    return true;
                }
                return false;
            } catch (error) {
                console.error('Error syncing product info:', error);
                return false;
            }
        },

        // 检查产品信息是否有变化
        hasProductInfoChanged(newProductInfo) {
            return (
                newProductInfo.price !== this.productInfo.price ||
                newProductInfo.isActive !== this.productInfo.isActive ||
                newProductInfo.strategyContract !== this.productInfo.strategyContract
            );
        },

        // 存储待处理交易
        storePendingTransaction(txHash, thirdPartyOrderId) {
            let pendingTx = JSON.parse(localStorage.getItem('pendingTx') || '[]');
            pendingTx.push({
                txHash: txHash,
                timestamp: Date.now(),
                user: this.userAdd,
                thirdPartyOrderId: thirdPartyOrderId, // 使用第三方订单ID
                status: 'pending'
            });
            localStorage.setItem('pendingTx', JSON.stringify(pendingTx));
        },

        // 本地重试队列：添加
        addToRetryQueue(thirdPartyOrderId, txHash, event) {
            let retryQueue = JSON.parse(localStorage.getItem('syncRetryQueue') || '[]');
            
            // 确保事件数据是 JSON 可序列化的
            const serializedEvent = this.convertBigNumberToJson(event);
            
            // 确保 returnValues 包含 chainId 和 token
            if (!serializedEvent.returnValues) {
                serializedEvent.returnValues = {};
            }
            serializedEvent.returnValues.chainId = process.env.NODE_ENV === 'development' ? 97 : 56;
            serializedEvent.returnValues.token = getCoinContract().options.address;
            
            retryQueue.push({
                thirdPartyOrderId,
                txHash,
                event: serializedEvent,
                timestamp: Date.now(),
                retryCount: 0
            });
            
            localStorage.setItem('syncRetryQueue', this.serializeBigInt(retryQueue));
        },

        // 本地重试队列：移除
        removeFromRetryQueue(thirdPartyOrderId, txHash) {
            let retryQueue = JSON.parse(localStorage.getItem('syncRetryQueue') || '[]');
            retryQueue = retryQueue.filter(item => !(item.thirdPartyOrderId === thirdPartyOrderId && item.txHash === txHash));
            localStorage.setItem('syncRetryQueue', this.serializeBigInt(retryQueue));
        },

        // 同步到第三方，失败自动入队
        async syncToThirdParty(thirdPartyOrderId, txHash, event, retryCount = 0) {
            const maxRetries = 3;
            try {
                // 确保事件数据是 JSON 可序列化的
                const serializedEvent = this.convertBigNumberToJson(event);
                
                // 确保 returnValues 包含 chainId 和 token
                if (!serializedEvent.returnValues) {
                    serializedEvent.returnValues = {};
                }
                serializedEvent.returnValues.chainId = process.env.NODE_ENV === 'development' ? 97 : 56;
                serializedEvent.returnValues.token = getCoinContract().options.address;
                
                // 打印序列化后的事件数据，用于调试
                console.log('Serialized event data:', serializedEvent);
                
                let order = await updateOrder(thirdPartyOrderId, txHash, serializedEvent);

                if (order.status === 1 || order.message == "Order not found") {
                    this.removeFromRetryQueue(thirdPartyOrderId, txHash);
                    return true;
                }

                if (retryCount < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, Math.pow(2, retryCount) * 1000));
                    return this.syncToThirdParty(thirdPartyOrderId, txHash, event, retryCount + 1);
                }

                this.addToRetryQueue(thirdPartyOrderId, txHash, event);
                throw new Error('Max retries reached for third party sync');
            } catch (error) {
                console.error('Error in syncToThirdParty:', error);
                if (retryCount < maxRetries) {
                    await new Promise(resolve => setTimeout(resolve, Math.pow(2, retryCount) * 1000));
                    return this.syncToThirdParty(thirdPartyOrderId, txHash, event, retryCount + 1);
                }
                this.addToRetryQueue(thirdPartyOrderId, txHash, event);
                throw error;
            }
        },

        // 重试本地队列
        async processRetryQueue() {
            let retryQueue = JSON.parse(localStorage.getItem('syncRetryQueue') || '[]');
            const maxRetries = 5;
            for (let i = retryQueue.length - 1; i >= 0; i--) {
                const item = retryQueue[i];
                if (item.retryCount >= maxRetries) {
                    retryQueue.splice(i, 1);
                    continue;
                }
                try {
                    await this.syncToThirdParty(item.thirdPartyOrderId, item.txHash, item.event, item.retryCount);
                    retryQueue.splice(i, 1); // 成功后移除
                } catch (error) {
                    item.retryCount++;
                }
            }
            localStorage.setItem('syncRetryQueue', this.serializeBigInt(retryQueue));
        },

        // 清理交易记录
        cleanupTransaction(tx) {
            let pledge_result = JSON.parse(localStorage.getItem("pledge_queue"));
            if(!pledge_result) {
                pledge_result = [];
            }
            let buyIndex = localStorage.getItem("buyMobileIndex");
            delete pledge_result[buyIndex];
            localStorage.setItem('pledge_queue', this.serializeBigInt(pledge_result));
            localStorage.setItem("buyMobileIndex", buyIndex);
            
            const pendingTx = JSON.parse(localStorage.getItem('pendingTx'));
            const lastPendingTx = pendingTx.filter(t => t.txHash !== tx.txHash);
            localStorage.setItem('pendingTx', this.serializeBigInt(lastPendingTx));
            
            this.loading?.close();
            this.buttonLoading = false;
            this.visible = false;
            this.$message.success(this.$t('views_home_components_pledge_49'));
        },

        // 处理离线交易
        async handleOfflineTransaction(tx) {
            try {
                const receipt = await this.switchProvider(tx.txHash);
                if (receipt?.status) {
                    // 使用第三方订单ID进行同步
                    await this.syncToThirdParty(tx.thirdPartyOrderId, tx.txHash, receipt);
                    this.cleanupTransaction(tx);
                }
            } catch (error) {
                console.error('Error handling offline transaction:', error);
            }
        },
    }
}
</script>
<style>
.pledge-container {
    width: 100%;
}

.product-info {
    margin-top: 20px;
}

.el-select .el-input {
    width: auto;
}

.input-with-select .el-input-group__prepend {
    background-color: #fff;
}
</style>